import React, { useContext } from 'react'
import { EasybakeContext } from '../EasybakeProvider'
import Switch from '@react/react-spectrum/Switch'

export default function MySwitch ({
    group,
    action,
    checked,
    label,
    position = 'labelLeft'
}) {
    const { dispatch, group: stateGroup, action: stateAction } = useContext(EasybakeContext)
    const isChecked = (stateGroup === group && stateAction === action)

    return (
        <div className={`switchgroup ${position}`}>
            {position === 'labelLeft' &&
          <React.Fragment>
              <span className="spectrum-ToggleSwitch-label">
                  {label}
              </span>
              <Switch checked={checked || isChecked} aria-label={label} onChange={(on) => dispatch({ type: 'set-action', payload: { group, action, on } })} />
          </React.Fragment>
            }
            {position === 'labelRight' &&
          <Switch checked={checked || isChecked} label={label} onChange={(on) => dispatch({ type: 'set-action', payload: { group, action, on } })} />
            }
        </div>
    )
}
